module.exports = __webpack_public_path__ + "static/media/hero_mobile.0b6799a4.webp";